var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "apartments" },
    [
      _c("h1", { staticClass: "text-center title--accent-center" }, [
        _vm._v("LISTA NIERUCHOMOŚCI")
      ]),
      _vm._v(" "),
      _c("apartment-selector", {
        attrs: { apartments: _vm.apartments },
        on: { selectorApartment: _vm.handleApartmentSelection }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "apartments__filters" }, [
        _c("div", { staticClass: "menu" }, [
          _c(
            "div",
            {
              staticClass: "menu__item",
              class: { "menu__item--active": this.status == false },
              on: {
                click: function($event) {
                  return _vm.setStatus(false)
                }
              }
            },
            [_vm._v("\n        Wszystkie\n      ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "menu__item",
              class: { "menu__item--active": this.status == "wolne" },
              on: {
                click: function($event) {
                  return _vm.setStatus("wolne")
                }
              }
            },
            [_vm._v("\n        Wolne\n      ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "menu__item",
              class: { "menu__item--active": this.status == "rezerwacja" },
              on: {
                click: function($event) {
                  return _vm.setStatus("rezerwacja")
                }
              }
            },
            [_vm._v("\n        Rezerwacja\n      ")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "apartments-list" },
          _vm._l(_vm.filteredApartments.slice(0, this.limit), function(
            apartment
          ) {
            return _vm.filteredApartments.length > 0
              ? _c("apartment-card", {
                  key: apartment.id,
                  attrs: {
                    apartment: apartment,
                    investmentId:
                      apartment.investmentId || "default-investment-id"
                  },
                  on: {
                    apartmentSelected: _vm.handleApartmentSelection,
                    showPriceHistory: _vm.handleShowPriceHistory
                  }
                })
              : _vm._e()
          }),
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "apartments__button" }, [
          _vm.limit < this.filteredApartments.length
            ? _c(
                "div",
                {
                  staticClass: "btn btn--clickable",
                  on: { click: _vm.increaseLimit }
                },
                [_vm._v("\n        Więcej\n      ")]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("apartment-popup", {
        attrs: {
          isVisible: _vm.popupVisible,
          apartment: _vm.selected,
          investmentId:
            _vm.selected &&
            (_vm.selected.investmentId || "default-investment-id")
        },
        on: {
          closePopup: _vm.handlePopupClose,
          openForm: _vm.handleFormOpen,
          showPriceHistory: _vm.handleShowPriceHistory
        }
      }),
      _vm._v(" "),
      _c(
        "apartment-form",
        {
          staticClass: "apartment-form",
          attrs: {
            isVisible: _vm.isFormVisible,
            apartment: _vm.contactFormApartment
          },
          on: { closeForm: _vm.handleFormClose }
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c("price-history-popup", {
        attrs: {
          isVisible: _vm.showPriceHistoryPopup,
          apartmentId: _vm.priceHistoryData.apartmentId,
          investmentId: _vm.priceHistoryData.investmentId
        },
        on: { close: _vm.closePriceHistoryPopup }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7136756c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// /Users/mrkaluzny/Developer/tarasy-nad-stawem/web/app/themes/tarasy-nad-stawem/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7136756c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!/Users/mrkaluzny/Developer/tarasy-nad-stawem/web/app/themes/tarasy-nad-stawem/node_modules/vue-loader/lib/selector.js?type=template&index=0!./scripts/vue/components/ApartmentsList.vue
// module id = 61
// module chunks = 0